import { open_db_type } from '../interfaces';

declare const open_db: open_db_type;

// 讀取 indexedDB
export default function get_db(db_name: string | string[]): Promise<unknown[] | undefined> {
  return new Promise((resolve, reject) => {
    // !self.db_version[db_name] && (self.db_version[db_name] = 1);
    (Array.isArray(db_name)
      ? Promise.all(
          db_name.map(
            (name: string): Promise<unknown> => {
              return new Promise((resolve_2, reject_2) => {
                open_db(name).then((db: void | IDBDatabase): void | PromiseLike<void> => {
                  db
                    ? readwrite(db, name)
                        .then((value: unknown) => {
                          db.close();
                          setTimeout(() => {
                            !((value as unknown[] | undefined)?.[0] as any)?.code && resolve_2(value as unknown[] | undefined);
                          }, 0);
                        })
                        .catch(() => {
                          db.close();
                          setTimeout(() => {
                            reject_2();
                          }, 0);
                        })
                        .finally(() => {
                          setTimeout(() => {
                            db.close();
                            setTimeout(() => {
                              reject_2();
                            }, 0);
                          }, 5000);
                        })
                    : // .then((response: unknown) => {
                      //   resolve_2(response);
                      // })
                      // .catch(() => {
                      //   reject_2();
                      // })
                      reject_2();
                });
              });
            }
          )
        )
      : new Promise((resolve_2, reject_2) => {
          open_db(db_name).then((db: void | IDBDatabase): void | PromiseLike<void> => {
            db &&
              db_name &&
              readwrite(db, db_name)
                .then((value: unknown) => {
                  db.close();
                  setTimeout(() => {
                    !((value as unknown[] | undefined)?.[0] as any)?.code && resolve_2(value as unknown[] | undefined);
                  }, 0);
                })
                .catch(() => {
                  db.close();
                  setTimeout(() => {
                    reject_2();
                  }, 0);
                })
                .finally(() => {
                  setTimeout(() => {
                    db.close();
                    setTimeout(() => {
                      reject_2();
                    }, 0);
                  }, 5000);
                });
            // .then((response: unknown) => {
            //   resolve_2(response);
            // })
            // .catch(() => {
            //   reject_2();
            // });
          });
        })
    )
      .then((result: any) => {
        resolve(result);
      })
      .catch(() => {
        reject();
      });
    // (Array.isArray(name)
    //   ? Promise.all(
    //       name.map(
    //         (item: string): Promise<unknown> => {
    //           return
    //         }
    //       )
    //     )

    // )
    // .then((value: unknown) => {
    //   db.close();
    //   setTimeout(() => {
    //     !((value as unknown[] | undefined)?.[0] as any)?.code && resolve(value as unknown[] | undefined);
    //   }, 0);
    // })
    // .catch(() => {
    //   db.close();
    //   setTimeout(() => {
    //     reject();
    //   }, 0);
    // })
    // .finally(() => {
    //   setTimeout(() => {
    //     db.close();
    //     setTimeout(() => {
    //       reject();
    //     }, 0);
    //   }, 5000);
    // });
    // })
    // .catch(() => {
    //   reject();
    // });
  });

  function readwrite(db: IDBDatabase, object_store_name: string): Promise<unknown | undefined> {
    return new Promise((resolve, reject) => {
      try {
        const tx: IDBTransaction = db.transaction(object_store_name, 'readwrite');
        const store: IDBObjectStore = tx.objectStore(object_store_name);
        const DBRequest: IDBRequest<any> = store.get(0);

        DBRequest.onsuccess = (): void => {
          resolve(DBRequest.result);
        };
        DBRequest.onerror = (): void => {
          console.error('Error writing database ' + db_name + '.');
        };
      } catch (err) {
        console.error('get', object_store_name, err);
        db.close();
        // setTimeout(() => {
        //   self.db_version[object_store_name] += 1;
        //   get_db(db_name).finally(() => {
        reject();
        //   });
        // }, 0);
      }
    });
  }
}
